import MainRoutes from "./Components/MainRoutes";


const App=()=> {
  return (
    <div className="App">
      <MainRoutes/>
    </div>
  );
}

export default App;
